import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.for-each.js";
import React from 'react';
import { useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import queryparse from 'tricks/string/queryparse';
import createLocation from 'utils/createLocation';
import Text from 'components/Text';
import Flex from 'components/Flex';
import Button from 'components/Button';
import InlineList from 'components/InlineList';
import useUniqueId from 'hooks/useUniqueId';
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
function FilterButtons(_ref) {
  var label = _ref.label,
    queryParam = _ref.queryParam,
    options = _ref.options,
    defaultOption = _ref.defaultOption;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t;
  var history = useHistory();
  var titleId = useUniqueId();
  var location = useLocation();
  var queryParams = queryparse(location.search);
  var _queryParams$queryPar = queryParams[queryParam],
    selectedOption = _queryParams$queryPar === void 0 ? defaultOption : _queryParams$queryPar;
  var changeFilter = function changeFilter(value) {
    history.replace(createLocation(location.pathname, _objectSpread(_objectSpread({}, queryParams), {}, _defineProperty(_defineProperty({}, queryParam, value), "page", undefined))));
  };
  return /*#__PURE__*/_jsxs(Flex, {
    wrap: true,
    as: "section",
    role: "group",
    "aria-labelledby": titleId,
    children: [/*#__PURE__*/_jsx(Text, {
      mr: "xs",
      id: titleId,
      children: label
    }), /*#__PURE__*/_jsx(InlineList, {
      spacing: "xxs",
      as: "div",
      itemAs: "div",
      children: options.map(function (filter) {
        var isActive = selectedOption === filter.value;
        return /*#__PURE__*/_jsx(Button, {
          size: "medium",
          variant: isActive ? 'primary' : 'transparent',
          onClick: function onClick() {
            return changeFilter(filter.value);
          },
          icon: isActive ? 'ok' : undefined,
          "aria-pressed": isActive,
          "aria-describedby": titleId,
          children: t(filter.labelTranslationKey)
        }, filter.value);
      })
    })]
  });
}
export default FilterButtons;